interface ButtonFilledSmallProps {
    label?: string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    fullWidth?: boolean;
    disabled?: boolean;
}

export default ({ label, onClick, fullWidth, disabled }: ButtonFilledSmallProps) => {
    return (
        <button
            onClick={onClick}
            type="button"
            disabled={disabled}
            className={`py-1.5 px-4 focus:ring-offset-blue-200 text-white transition ease-in duration-200 text-center text-sm font-semibold shadow-md focus:outline-none focus:ring-offset-2 rounded-md ${
                fullWidth ? 'w-full' : ''
            }

            ${disabled ? 'bg-gray-500' : `bg-blue-700 hover:bg-blue-900`}
            `}
        >
            {label}
        </button>
    );
};
